(() => {
  function normalize(str) {
    return (str || "").toString().toLowerCase().trim();
  }

  function init() {
    const input = document.getElementById("CollectionInstantSearch");
    const meta = document.getElementById("CollectionInstantSearchMeta");
    const grid = document.getElementById("product-grid");

    if (!input || !grid) return;

    const items = Array.from(grid.querySelectorAll("li.grid__item"));
    if (!items.length) return;

    function updateMeta(visibleCount, totalCount, term) {
      if (!meta) return;
      if (!term) {
        meta.textContent = "";
        return;
      }
      meta.textContent = `Showing ${visibleCount} of ${totalCount} on this page`;
    }

    function applyFilter(term) {
      const q = normalize(term);
      let visible = 0;

      for (const li of items) {
        const hay = normalize(li.getAttribute("data-search"));
        const match = !q || hay.includes(q);

        li.classList.toggle("is-filtered-out", !match);
        if (match) visible++;
      }

      updateMeta(visible, items.length, q);
    }

    // Debounce so it stays snappy
    let t = null;
    input.addEventListener("input", (e) => {
      clearTimeout(t);
      t = setTimeout(() => applyFilter(e.target.value), 80);
    });

    // Expose a tiny API for the clear button
    window.SkidCollectionFilter = {
      clear() {
        input.value = "";
        applyFilter("");
        input.focus();
      }
    };
  }

  // Run on normal load
  document.addEventListener("DOMContentLoaded", init);

  // Also run after Shopify updates the grid via facets.js (AJAX filtering/sorting)
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);

  // Dawn/Ride facets often re-render ProductGridContainer; re-init on that event if present
  document.addEventListener("facets:render", init);
})();